export const Title = "Title";
export const FirstName = "FirstName";
export const LastName = "LastName";
export const Gender = "Gender";
export const Dob = "Dob";
export const AddressLine1 = "AddressLine1";
export const AddressLine2 = "AddressLine2";
export const AddressLine3 = "AddressLine3";
export const City = "City";
export const County = "County";
export const Postcode = "Postcode";
export const MobilePhone = "MobilePhone";
export const HomePhone = "HomePhone";
export const HasDisability = "HasDisability";
export const EverHadDisability = "EverHadDisability";
export const HavingTreatment = "HavingTreatment";
export const HasConditionRequiringAdjustment = "HasConditionRequiringAdjustment";
export const FurtherDetails = "FurtherDetails";
export const CanProvideMmrVaccineEvidence = "CanProvideMmrVaccineEvidence";
export const MmrVaccineEvidence = "MmrVaccineEvidence";
export const CanProvideMeaslesRubellaTestEvidence = "CanProvideMeaslesRubellaTestEvidence";
export const MeaslesRubellaTestEvidence = "MeaslesRubellaTestEvidence";
export const CanProvideBcgCheckEvidence = "CanProvideBcgCheckEvidence";
export const BcgCheckEvidence = "BcgCheckEvidence";
export const CanProvideVaricellaEvidence = "CanProvideVaricellaEvidence";
export const VaricellaEvidence = "VaricellaEvidence";
export const CanProvideHepatitisBImmunityEvidence = "CanProvideHepatitisBImmunityEvidence";
export const HepatitisBImmunityEvidence = "HepatitisBImmunityEvidence";
export const HadChickenPox = "HadChickenPox";
export const HadChildhoodVaccinations = "HadChildhoodVaccinations";
export const HaveCoughMoreThan3Weeks = "HaveCoughMoreThan3Weeks";
export const HaveUnexplainedWeightLoss = "HaveUnexplainedWeightLoss";
export const HaveUnexplainedFever = "HaveUnexplainedFever";
export const HaveTuberculosis = "HaveTuberculosis";
export const TravelToTbAreas = "TravelToTbAreas";
export const LivedContinuouslyInUk = "LivedContinuouslyInUk";
export const CountriesLivedIn = "CountriesLivedIn";
export const CanProvideHepatitisBStatus = "CanProvideHepatitisBStatus";
export const HepatitisBStatusEvidence = "HepatitisBStatusEvidence";
export const CanProvideHepatitisCStatus = "CanProvideHepatitisCStatus";
export const HepatitisCStatusEvidence = "HepatitisCStatusEvidence";
export const CanProvideHivStatus = "CanProvideHivStatus";
export const HivStatusEvidence = "HivStatusEvidence";
export const HadHepatitisB = "HadHepatitisB";
export const HadHepatitisC = "HadHepatitisC";
export const HadHiv = "HadHiv";
export const HadHighRiskFromHep = "HadHighRiskFromHep";
export const HadTyphoid = "HadTyphoid";
export const HadBowelDisorders = "HadBowelDisorders";
export const HadTuberculosis = "HadTuberculosis";
export const HadAsthmaChestInfection = "HadAsthmaChestInfection";
export const HadRecurringSkinDisorders = "HadRecurringSkinDisorders";
export const HadAllergicReactions = "HadAllergicReactions";
export const HadBackNeckArmWristProblems = "HadBackNeckArmWristProblems";
export const HadDeafnessDefectiveVision = "HadDeafnessDefectiveVision";
export const HadBlackoutsDizzySpells = "HadBlackoutsDizzySpells";
export const HadRecentSkinInfection = "HadRecentSkinInfection";
export const HadRecentDiarrhoeaVomiting = "HadRecentDiarrhoeaVomiting";
export const HadRecentEarEyeGumInfection = "HadRecentEarEyeGumInfection";
export const HadTyphoidContact = "HadTyphoidContact";
export const OngoingSymptomsAndTreatments = "OngoingSymptomsAndTreatments";
export const PrivacyStatementConfirmation = "PrivacyStatementConfirmation";
export const TeamPreventProcessPersonalInfoConfirmation = "TeamPreventProcessPersonalInfoConfirmation";
export const InformationHeldSecurelyConfirmation = "InformationHeldSecurelyConfirmation";
export const FitnessToWorkProvidedToEmployerConfirmation = "FitnessToWorkProvidedToEmployerConfirmation";
export const AnswersTrueConfirmation = "AnswersTrueConfirmation";
export const Covid19RiskAssessmentStatementOfUnderstanding = "Covid19RiskAssessmentStatementOfUnderstanding";
export const Age = "Age";
export const GenderAtBirth = "GenderAtBirth";
export const Ethnicity = "Ethnicity";
export const Asthma = "Asthma";
export const Diabetes = "Diabetes";
export const ChronicKidneyDisease = "ChronicKidneyDisease";
export const CancerOtherThanLeukaemiaLymphomaOrMyeloma = "CancerOtherThanLeukaemiaLymphomaOrMyeloma";
export const LeukaemiaLymphomaOrMyeloma = "LeukaemiaLymphomaOrMyeloma";
export const Heart = "Heart";
export const OtherChronicRespiratorydDisease = "OtherChronicRespiratorydDisease";
export const Hypertension = "Hypertension";
export const CerebrovascularDisease = "CerebrovascularDisease";
export const LiverDisease = "LiverDisease";
export const ChronicNeurologicalDiseaseOtherThanStrokeOrDementia = "ChronicNeurologicalDiseaseOtherThanStrokeOrDementia";
export const OrganTransplant = "OrganTransplant";
export const SpleenDiseases = "SpleenDiseases";
export const RheumatoidLupusPsoriasis = "RheumatoidLupusPsoriasis";
export const OtherImmunosuppresiveCondition = "OtherImmunosuppresiveCondition";
export const Covid19VaccineStatus = "Covid19VaccineStatus";
export const Covid19FirstVaccineStatus = "Covid19FirstVaccineStatus";
export const Covid19FirstVaccineDate = "Covid19FirstVaccineDate";
export const Covid19FirstVaccineType = "Covid19FirstVaccineType";
export const Covid19SecondVaccineStatus = "Covid19SecondVaccineStatus";
export const Covid19SecondVaccineDate = "Covid19SecondVaccineDate";
export const Covid19SecondVaccineType = "Covid19SecondVaccineType";
export const Covid19VaccineDeclaration = "Covid19VaccineDeclaration";
export const Bmi = "Bmi";
export const CovidRiskAge = "CovidRiskAge";
export const CovidRiskGroup = "CovidRiskGroup";
export const CovidFinalRiskGroup = "CovidFinalRiskGroup";
export const CovidVaccinationStatus = "CovidVaccinationStatus";
export const CovidVaccinationDate = "CovidVaccinationDate";
export const CovidVaccinationEvidenceRequiredConsent = "CovidVaccinationEvidenceRequiredConsent";
export const CovidVaccinationEvidenceSharingConsent = "CovidVaccinationEvidenceSharingConsent";
export const CovidVaccineEvidence = "CovidVaccineEvidence";
